import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

class ProductDetails extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateFlavour);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateFlavour);
  }

  /**
   * Updates the flavour display when variant changes
   * @param {import('@theme/events').VariantUpdateEvent} event 
   */
  updateFlavour = (event) => {
    console.log('Variant update event:', event.detail.resource);
    
    const flavourDiv = this.querySelector('.view-product-flavour');
    const flavourNameSpan = flavourDiv?.querySelector('.flavour-name');
    if (!flavourDiv || !flavourNameSpan) return;

    // Get the new flavour value from the variant
    const newHtml = event.detail.data.html;
    const newFlavourDiv = newHtml.querySelector('.view-product-flavour');
    const newFlavourName = newFlavourDiv?.querySelector('.flavour-name')?.textContent;

    if (newFlavourName) {
      flavourNameSpan.textContent = newFlavourName;
      flavourDiv.removeAttribute('hidden');
      console.log('Flavour updated to:', newFlavourName);
    } else {
      flavourDiv.setAttribute('hidden', '');
    }
  };
}

customElements.define('product-details', ProductDetails); 